import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16 md:pt-[72px]">
        <div className="relative w-full px-4 md:px-8 py-24 flex flex-col items-center justify-center text-center min-h-[70vh]">
          <p className="font-display text-[88px] md:text-[140px] leading-none font-semibold text-background-200 select-none">
            404
          </p>
          <h1 className="mt-2 text-xl md:text-2xl font-bold text-foreground-950">
            页面走丢了
          </h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-md">
            你访问的地址 <span className="text-foreground-900 font-mono text-xs">{location.pathname}</span>{" "}
            不存在，可能已经调整或输入有误。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="h-11 px-6 inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/category"
              className="h-11 px-6 inline-flex items-center gap-2 rounded-md bg-background-100 hover:bg-background-200 border border-background-400 text-foreground-900 text-sm transition-colors whitespace-nowrap"
            >
              浏览影片分类
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}